import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const DevDocs: React.FC = () => {
  return (
    <section className='home-content-body Home-HeaderDown' style={{ minHeight: 0 }} >
      <Grid container>
        <Grid item xs={12}>
          <div className='module-header'>
            <div className='module-header-breadcrumbs'>
              <Link to='/'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M7.5 17.5V11.3333C7.5 10.8666 7.5 10.6333 7.59083 10.455C7.67072 10.2982 7.79821 10.1707 7.95501 10.0908C8.13327 9.99999 8.36662 9.99999 8.83333 9.99999H11.1667C11.6334 9.99999 11.8667 9.99999 12.045 10.0908C12.2018 10.1707 12.3293 10.2982 12.4092 10.455C12.5 10.6333 12.5 10.8666 12.5 11.3333V17.5M9.18141 2.30333L3.52949 6.69927C3.15168 6.99312 2.96278 7.14005 2.82669 7.32405C2.70614 7.48704 2.61633 7.67065 2.56169 7.86588C2.5 8.08627 2.5 8.32558 2.5 8.80421V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1585 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5H14.8333C15.7668 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1585 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V8.80421C17.5 8.32558 17.5 8.08627 17.4383 7.86588C17.3837 7.67065 17.2939 7.48704 17.1733 7.32405C17.0372 7.14005 16.8483 6.99312 16.4705 6.69927L10.8186 2.30333C10.5258 2.07562 10.3794 1.96177 10.2178 1.918C10.0752 1.87938 9.92484 1.87938 9.78221 1.918C9.62057 1.96177 9.47418 2.07562 9.18141 2.30333Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </Link>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path d='M6 12L10 8L6 4' stroke='#D0D5DD' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <div className='bc-title'>
                BITE API
              </div>
            </div>
            <div className='homepage-header-title-cont'>
              <h1>BITE API</h1>
              <h2>Gain access directly to the BITE&apos;s API via Snowflake Marketplace</h2>
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>
          <div className='support-link-grp'>
            <div className='support-module'>
              <a href='https://app.snowflake.com/marketplace/listing/GZTSZ12PL2T/bite-us-international-watchlists' target='_blank' rel='noopener noreferrer' className='hover-box'>
                <div className='module-icon'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path d='M5 10V16.0111C5 16.3701 5 16.5496 5.05465 16.708C5.10299 16.8482 5.18187 16.9758 5.28558 17.0817C5.40287 17.2014 5.5634 17.2817 5.88446 17.4422L11.2845 20.1422C11.5468 20.2734 11.678 20.339 11.8156 20.3648C11.9375 20.3877 12.0625 20.3877 12.1844 20.3648C12.322 20.339 12.4532 20.2734 12.7155 20.1422L18.1155 17.4422C18.4366 17.2817 18.5971 17.2014 18.7144 17.0817C18.8181 16.9758 18.897 16.8482 18.9453 16.708C19 16.5496 19 16.3701 19 16.0111V10M2 8.5L11.6422 3.67889C11.7734 3.6133 11.839 3.5805 11.9078 3.5676C11.9687 3.55616 12.0313 3.55616 12.0922 3.5676C12.161 3.5805 12.2266 3.6133 12.3578 3.67889L22 8.5L12.3578 13.3211C12.2266 13.3867 12.161 13.4195 12.0922 13.4324C12.0313 13.4438 11.9687 13.4438 11.9078 13.4324C11.839 13.4195 11.7734 13.3867 11.6422 13.3211L2 8.5Z' stroke='#E5F2FD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
                <div className='support-info'>
                  <div className='module-title'>
                    <h2>Watchlist</h2>
                  </div>
                  <div className='module-desc'>
                    <Typography
                      variant='subtitle2'
                    >
                  The Watchlist serves as a database where you can search all internationally flagged entities.
                    </Typography>
                  </div>
                </div>
              </a>
            </div>


            <div className='support-module'>
              <a href='https://app.snowflake.com/marketplace/listing/GZTSZ12PL2L/bite-trade-protection' target='_blank' rel='noopener noreferrer' className='hover-box'>
                <div className='module-icon'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path d='M5 10V16.0111C5 16.3701 5 16.5496 5.05465 16.708C5.10299 16.8482 5.18187 16.9758 5.28558 17.0817C5.40287 17.2014 5.5634 17.2817 5.88446 17.4422L11.2845 20.1422C11.5468 20.2734 11.678 20.339 11.8156 20.3648C11.9375 20.3877 12.0625 20.3877 12.1844 20.3648C12.322 20.339 12.4532 20.2734 12.7155 20.1422L18.1155 17.4422C18.4366 17.2817 18.5971 17.2014 18.7144 17.0817C18.8181 16.9758 18.897 16.8482 18.9453 16.708C19 16.5496 19 16.3701 19 16.0111V10M2 8.5L11.6422 3.67889C11.7734 3.6133 11.839 3.5805 11.9078 3.5676C11.9687 3.55616 12.0313 3.55616 12.0922 3.5676C12.161 3.5805 12.2266 3.6133 12.3578 3.67889L22 8.5L12.3578 13.3211C12.2266 13.3867 12.161 13.4195 12.0922 13.4324C12.0313 13.4438 11.9687 13.4438 11.9078 13.4324C11.839 13.4195 11.7734 13.3867 11.6422 13.3211L2 8.5Z' stroke='#E5F2FD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
                <div className='support-info'>
                  <div className='module-title'>
                    <h2>Trade Protection</h2>
                  </div>
                  <div className='module-desc'>
                    <Typography
                      variant='subtitle2'
                    >
                  The Trade Protection module serves as a database where you can search commodities related to various global controls.
                    </Typography>
                  </div>
                </div>
              </a>
            </div>

            <div className='support-module'>
              <a href='https://app.snowflake.com/marketplace/listing/GZTSZ12PL2P/bite-cyber-protection' target='_blank' rel='noopener noreferrer' className='hover-box'>
                <div className='module-icon'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path d='M5 10V16.0111C5 16.3701 5 16.5496 5.05465 16.708C5.10299 16.8482 5.18187 16.9758 5.28558 17.0817C5.40287 17.2014 5.5634 17.2817 5.88446 17.4422L11.2845 20.1422C11.5468 20.2734 11.678 20.339 11.8156 20.3648C11.9375 20.3877 12.0625 20.3877 12.1844 20.3648C12.322 20.339 12.4532 20.2734 12.7155 20.1422L18.1155 17.4422C18.4366 17.2817 18.5971 17.2014 18.7144 17.0817C18.8181 16.9758 18.897 16.8482 18.9453 16.708C19 16.5496 19 16.3701 19 16.0111V10M2 8.5L11.6422 3.67889C11.7734 3.6133 11.839 3.5805 11.9078 3.5676C11.9687 3.55616 12.0313 3.55616 12.0922 3.5676C12.161 3.5805 12.2266 3.6133 12.3578 3.67889L22 8.5L12.3578 13.3211C12.2266 13.3867 12.161 13.4195 12.0922 13.4324C12.0313 13.4438 11.9687 13.4438 11.9078 13.4324C11.839 13.4195 11.7734 13.3867 11.6422 13.3211L2 8.5Z' stroke='#E5F2FD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
                <div className='support-info'>
                  <div className='module-title'>
                    <h2>Cyber Protection</h2>
                  </div>
                  <div className='module-desc'>
                    <Typography
                      variant='subtitle2'
                    >
                  The Cyber Protection module serves as a database where you can search lists related to cyber controls, IP addresses, and counterfeit markets.
                    </Typography>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className='dev-docs-container'>
            <object data={'https://bite-app.s3.amazonaws.com/dev+docs/BITE+Score+API+Docs.pdf'} type='application/pdf' width='80%' height='700px'>
              <p>Your web browser doesn&apos;t have a PDF plugin.
                <a href={'https://bite-app.s3.amazonaws.com/dev+docs/BITE+Score+API+Docs.pdf'}>click here to download the PDF file.</a>
              </p>
            </object>
          </div>
        </div>
      </Grid>
    </section>
  );
};

export default DevDocs;


